import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';
import PropTypes from 'prop-types';

class SelectInput extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            select: props.select,
        }
        this.onChange = this.onChange.bind(this)
    }

    componentDidUpdate(prevProps){
        if(this.props.select !== prevProps.select){
            this.setState({
                select: this.props.select
            })
        }
    }

    onChange(e){
        e.target.name = this.props.name
        this.props.onChange(e)
        this.setState({
            select: e.target.value
        })
    }
    _renderList(values){
        var selects = []
        for(var value in values){
            selects.push(<option value={value} key={value}> {values[value]} </option>)
        }
        return selects
    }

    render() {
        const {values, ...rest} = this.props
        return(
            <Flex {...rest} column className={style.SelectWrapper} width={this.props.width} shrink={0}>
                <select value={this.state.select} onChange={this.onChange} disabled={this.props.disabled}>
                    {this._renderList(values)}
                </select>
            </Flex>
        );
    }
}

export default SelectInput;



// WEBPACK FOOTER //
// src/component/Forms/SelectInput/index.js